import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-ignatius',
  imports: [Link, RouterLink],
  templateUrl: './ignatius.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ignatius.scss',
})
export class Ignatius {
  dynamicTitle = inject(TitleChange);

  constructor() {
    this.dynamicTitle.title('Ignatius of Antioch');
    this.dynamicTitle.description('Ignatius was an early church father who might also be Peregrinus Proteus.');
  }
}
